import { render, staticRenderFns } from "./GruppoEdit.vue?vue&type=template&id=48d7f741"
import script from "./GruppoEdit.vue?vue&type=script&lang=js"
export * from "./GruppoEdit.vue?vue&type=script&lang=js"
import style0 from "./GruppoEdit.vue?vue&type=style&index=0&id=48d7f741&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports